import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const deleteSkill = id => {
  return dispatch => {
    dispatch({ type: "DELETE_SKILL_LOADING" });
    api
      .skillDelete(id)
      .then(resp => {
        dispatch(operationSucceeded(id));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "DeleteSkillErrorAlertTitle",
          "Virhe poistaessa taitoa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = (id) => ({
  type: "DELETE_SKILL_SUCCEEDED",
  payload: { skill: { skillId: id, rowId: id } }
});

const operationFail = () => ({
  type: "DELETE_SKILL_FAIL"
});
